import {Component} from '@angular/core';

@Component({
    selector: 'acabim-admin-site-config',
    template: '<acabim-admin-main-site-settings></acabim-admin-main-site-settings>'
})
export class ACAAdminSiteConfigComponent {

}
